export enum ReportIdentifier {
  armOverTime = 'armOverTime',
  sessionOverTime = 'sessionOverTime',
  nodeOverTime = 'nodeOverTime',
  topNodes = 'topNodes',
  topNodesOverTime = 'topNodesOverTime',
  nodeStackedByPeerConnection = 'nodeStackedByPeerConnection',
  topNodesStckedByPeerConnection = 'topNodesStckedByPeerConnection',
  peerConnectionOverTime = 'peerConnectionOverTime',
  topPeerConnections = 'topPeerConnections',
  topPeerConnectionsOverTime = 'topPeerConnectionsOverTime',
  connectionOverTime = 'connectionOverTime',
  topConnections = 'topConnections',
  topConnectionsOverTime = 'topConnectionsOverTime',
  routerOverTime = 'routerOverTime',
  topRouters = 'topRouters',
  topRoutersOverTime = 'topRoutersOverTime',
  routingGroupOverTime = 'routingGroupOverTime',
  topRoutingGroups = 'topRoutingGroups',
  topRoutingGroupsOverTime = 'topRoutingGroupsOverTime',
  routingGroupsStackedByRoutingRules = 'routingGroupsStackedByRoutingRules',
  topRoutingGroupsStackedByRoutingRules = 'topRoutingGroupsStackedByRoutingRules',
  routingRuleOverTime = 'routingRuleOverTime',
  topRoutingRules = 'topRoutingRules',
  topRoutingRulesOverTime = 'topRoutingRulesOverTime',
  routingRuleStackedByActions = 'routingRuleStackedByActions',
  topRoutingRulesStackedByActions = 'topRoutingRulesStackedByActions'
}
